// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// icons
import { Icon } from '@iconify/react';
import activityOutline from '@iconify/icons-eva/activity-outline';
import shoppingBagOutline from '@iconify/icons-eva/shopping-bag-outline';
import peopleOutline from '@iconify/icons-eva/people-outline';
import creditCardOutline from '@iconify/icons-eva/credit-card-outline';
import cubeOutline from '@iconify/icons-eva/cube-outline';
import carOutline from '@iconify/icons-eva/car-outline';
import personDoneOutline from '@iconify/icons-eva/person-done-outline';
import fileTextOutline from '@iconify/icons-eva/file-text-outline';
import barChartOutline from '@iconify/icons-eva/bar-chart-outline';

// ----------------------------------------------------------------------

const getIcon = (iconData) => (
  <Icon icon={iconData} width={22} height={22} />
);

const ICONS = {
  dashboard: getIcon(activityOutline),
  pointOfSale: getIcon(shoppingBagOutline),
  customer: getIcon(peopleOutline),
  expenses: getIcon(creditCardOutline),
  inventory: getIcon(cubeOutline),
  purchase: getIcon(carOutline),
  staff: getIcon(personDoneOutline),
  activityLog: getIcon(fileTextOutline),
  reports: getIcon(barChartOutline)
};

const sidebarConfig = [
  {
    subheader: 'general',
    items: [
      {
        title: 'dashboard',
        path: PATH_DASHBOARD.general.maindashboard,
        icon: ICONS.dashboard
      },
      {
        title: 'point of sale',
        path: PATH_DASHBOARD.pointofsale.root,
        icon: ICONS.pointOfSale,
        moduleId: '13',
        children: [
          { title: 'customer lookup', path: PATH_DASHBOARD.pointofsale.customerlookup, permissionId: 131 },
          { title: 'all orders', path: PATH_DASHBOARD.pointofsale.allorders, permissionId: 175 },
          { title: 'reverse tax calculator', path: PATH_DASHBOARD.pointofsale.reversetaxcalculator },
          { title: 'printer settings', path: PATH_DASHBOARD.pointofsale.printersettings, permissionId: 174 },
        ]
      },
      {
        title: 'customer management',
        path: PATH_DASHBOARD.general.customermanagement,
        icon: ICONS.customer,
        moduleId: '3',
        permissionId: 131
      },
      {
        title: 'expenses',
        path: PATH_DASHBOARD.expenses.root,
        icon: ICONS.expenses,
        moduleId: '20',
        children: [
          { title: 'all expenses', path: PATH_DASHBOARD.expenses.allexpenses, permissionId: 173 },
          { title: 'expense types', path: PATH_DASHBOARD.expenses.expensetype, permissionId: 179 },
        ]
      },
      {
        title: 'inventory',
        path: PATH_DASHBOARD.inventory.root,
        icon: ICONS.inventory,
        moduleId: '10',
        children: [
          { title: 'inventory', path: PATH_DASHBOARD.inventory.inventorylist, permissionId: 34 },
          { title: 'inventory audit', path: PATH_DASHBOARD.inventory.inventoryaudit, permissionId: 160 },
          { title: 'category types', path: PATH_DASHBOARD.inventory.categorytype },
          // { title: 'data variable', path: PATH_DASHBOARD.inventory.datavariable },
          { title: 'product category', path: PATH_DASHBOARD.inventory.productcategory, permissionId: 34 },
          { title: 'tax category', path: PATH_DASHBOARD.inventory.taxcategory, permissionId: 34 },
          { title: 'print barcode', path: PATH_DASHBOARD.inventory.printbarcode, permissionId: 38 },
          // {
          //   title: 'inventory transfer',
          //   path: PATH_DASHBOARD.inventory.inventory, 
          //   children: [
          //     { title: 'all outgoing transfers', path: PATH_DASHBOARD.inventory.alloutgoingtransfers  },
          //     { title: 'all incoming transfers', path: PATH_DASHBOARD.inventory.allincomingtransfers },
          //     { title: 'held transfer orders', path: PATH_DASHBOARD.inventory.heldtransferorders  },
          //     { title: 'transfers', path: PATH_DASHBOARD.inventory.transfers },
          //   ]
          // },
        ]
      },
      {
        title: 'purchase',
        path: PATH_DASHBOARD.purchase.root,
        icon: ICONS.purchase,
        moduleId: '2',
        children: [
          { title: 'all suppliers', path: PATH_DASHBOARD.purchase.allsuppliers, permissionId: 81 },
          { title: 'all supplier types', path: PATH_DASHBOARD.purchase.allsuppliertypes, permissionId: 180, excludeFromModuleCheck: true },
          { title: 'receive inventory orders', path: PATH_DASHBOARD.purchase.receiveinventoryorders, permissionId: 134 }
        ]
      },
      {
        title: 'staff management',
        path: PATH_DASHBOARD.staffmanagement.root,
        icon: ICONS.staff,
        moduleId: '15',
        children: [
          { title: 'staff directory', path: PATH_DASHBOARD.staffmanagement.staffdirectory, permissionId: 98 },
          { title: 'user roles', path: PATH_DASHBOARD.staffmanagement.userroles, permissionId: 177 },
          { title: 'staff scheduler', path: PATH_DASHBOARD.staffmanagement.staffscheduler},
          // { title: 'staff time tracking', path: PATH_DASHBOARD.staffmanagement.stafftimetracking},
        ]
      },
      { title: 'activity log', path: PATH_DASHBOARD.general.activitylog, icon: ICONS.activityLog, moduleId: '19' },
      {
        title: 'reports',
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.reports,
        moduleId: '16',
        children: [
          { title: 'profit loss', path: PATH_DASHBOARD.reports.profitloss },
          { title: 'customers', path: PATH_DASHBOARD.reports.customers, permissionId: 157 },
          { title: 'customer outstanding', path: PATH_DASHBOARD.reports.customeroutstandingreports, permissionId: 157 },
          { title: 'staffs', path: PATH_DASHBOARD.reports.staffs, permissionId: 128 },
          { title: 'expenses', path: PATH_DASHBOARD.reports.expenses },
          {
            title: 'inventory',
            path: PATH_DASHBOARD.reports.reports, 
            permissionId: 158,
            children: [
              { title: 'products', path: PATH_DASHBOARD.reports.products  },
              { title: 'receive inventory', path: PATH_DASHBOARD.reports.receiveinventory }
            ]
          },
          {
            title: 'sales',
            path: PATH_DASHBOARD.reports.reports, 
            permissionId: 155,
            children: [
              { title: 'sales', path: PATH_DASHBOARD.reports.sales  },
              { title: 'sales by filter', path: PATH_DASHBOARD.reports._salesbyfilter },
              { title: 'refunded sales', path: PATH_DASHBOARD.reports.refundedsales  },
              { title: 'sales by category', path: PATH_DASHBOARD.reports._salesbycategory },
              { title: 'sales counts', path: PATH_DASHBOARD.reports._salescounts  },
              { title: 'sales count by hour', path: PATH_DASHBOARD.reports._salescountbyhour },
              { title: 'sales count by day', path: PATH_DASHBOARD.reports._salescountbyday  },
              { title: 'sales count by day & hour', path: PATH_DASHBOARD.reports.__salescountbydayandhour },
              { title: 'best seller', path: PATH_DASHBOARD.reports.bestseller  },
              { title: 'best sellers by quantity', path: PATH_DASHBOARD.reports._bestsellersbyquantity },
              { title: 'worst sellers', path: PATH_DASHBOARD.reports.worstsellers  },
              { title: 'worst sellers by quantity', path: PATH_DASHBOARD.reports._worstsellersbyquantity },
              { title: 'payments', path: PATH_DASHBOARD.reports._payments },
            ]
          },
          {
            title: 'payments',
            path: PATH_DASHBOARD.reports.reports, 
            children: [
              { title: 'customer pending payments', path: PATH_DASHBOARD.reports._customerpendingpayments },
            ]
          },
        ]
      },
    ]
  }
];

export default sidebarConfig;